var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "chart-page" }, [
        _c("div", { staticClass: "card search-card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("主要經驗分類"),
                    ]),
                    _c(
                      "el-select",
                      {
                        staticClass: "w-100",
                        attrs: {
                          filterable: "",
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                        },
                        model: {
                          value: _vm.search.ResumeTagGuids,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "ResumeTagGuids", $$v)
                          },
                          expression: "search.ResumeTagGuids",
                        },
                      },
                      _vm._l(_vm.resumeTagList, function (item) {
                        return _c("el-option", {
                          key: item.Guid,
                          attrs: { label: item.Name, value: item.Guid },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("預約面談日期(起)"),
                    ]),
                    _c("el-date-picker", {
                      staticClass: "w-100",
                      attrs: {
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.search.InterviewDateStart,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "InterviewDateStart", $$v)
                        },
                        expression: "search.InterviewDateStart",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("預約面談日期(迄)"),
                    ]),
                    _c("el-date-picker", {
                      staticClass: "w-100",
                      attrs: {
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.search.InterviewDateEnd,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "InterviewDateEnd", $$v)
                        },
                        expression: "search.InterviewDateEnd",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [_vm._v("職缺名稱")]),
                    _c(
                      "el-select",
                      {
                        staticClass: "w-100",
                        attrs: {
                          filterable: "",
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                          placeholder: "請選擇",
                        },
                        model: {
                          value: _vm.search.ManpowerDemandNos,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "ManpowerDemandNos", $$v)
                          },
                          expression: "search.ManpowerDemandNos",
                        },
                      },
                      _vm._l(_vm.manpowerDemandNoList, function (item) {
                        return _c("el-option", {
                          key: item.ManpowerDemandNo,
                          attrs: {
                            label: `${item.ManpowerDemandNo}-${item.ManpowerDemandName}`,
                            value: item.ManpowerDemandNo,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [_vm._v("面談結果")]),
                    _c(
                      "el-select",
                      {
                        staticClass: "w-100",
                        attrs: {
                          filterable: "",
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                          placeholder: "請選擇",
                        },
                        model: {
                          value: _vm.search.InterviewApprovalResults,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.search,
                              "InterviewApprovalResults",
                              $$v
                            )
                          },
                          expression: "search.InterviewApprovalResults",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "錄取", value: "錄取" },
                        }),
                        _c("el-option", {
                          attrs: { label: "考慮中", value: "考慮中" },
                        }),
                        _c("el-option", {
                          attrs: { label: "複試", value: "複試" },
                        }),
                        _c("el-option", {
                          attrs: { label: "不錄取", value: "不錄取" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("HCPInfo所在廠區"),
                    ]),
                    _c(
                      "el-select",
                      {
                        staticClass: "w-100",
                        attrs: {
                          filterable: "",
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                          placeholder: "請選擇",
                        },
                        model: {
                          value: _vm.search.EmployeePlantGuids,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "EmployeePlantGuids", $$v)
                          },
                          expression: "search.EmployeePlantGuids",
                        },
                      },
                      _vm._l(_vm.employeePlantList, function (item) {
                        return _c("el-option", {
                          key: item.Guid,
                          attrs: { label: item.Name, value: item.Guid },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [_vm._v("班別")]),
                    _c(
                      "el-select",
                      {
                        staticClass: "w-100",
                        attrs: {
                          filterable: "",
                          multiple: "",
                          "collapse-tags": "",
                          clearable: "",
                          placeholder: "請選擇",
                        },
                        model: {
                          value: _vm.search.WorkShiftTypeGuids,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "WorkShiftTypeGuids", $$v)
                          },
                          expression: "search.WorkShiftTypeGuids",
                        },
                      },
                      _vm._l(_vm.workShiftList, function (item) {
                        return _c("el-option", {
                          key: item.Guid,
                          attrs: { label: item.Name, value: item.Guid },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("預計報到日期(起)"),
                    ]),
                    _c("el-date-picker", {
                      staticClass: "w-100",
                      attrs: {
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.search.OnBoardDateStart,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "OnBoardDateStart", $$v)
                        },
                        expression: "search.OnBoardDateStart",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [
                      _vm._v("預約報到日期(迄)"),
                    ]),
                    _c("el-date-picker", {
                      staticClass: "w-100",
                      attrs: {
                        type: "date",
                        "value-format": "yyyy-MM-dd",
                        placeholder: "請選擇",
                      },
                      model: {
                        value: _vm.search.OnBoardDateEnd,
                        callback: function ($$v) {
                          _vm.$set(_vm.search, "OnBoardDateEnd", $$v)
                        },
                        expression: "search.OnBoardDateEnd",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [_vm._v("報到結果")]),
                    _c(
                      "el-select",
                      {
                        staticClass: "w-100",
                        attrs: {
                          clearable: "",
                          multiple: "",
                          "collapse-tags": "",
                          placeholder: "請選擇",
                        },
                        model: {
                          value: _vm.search.OnBoardStatuses,
                          callback: function ($$v) {
                            _vm.$set(_vm.search, "OnBoardStatuses", $$v)
                          },
                          expression: "search.OnBoardStatuses",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "簽核中", value: -999 },
                        }),
                        _c("el-option", {
                          attrs: { label: "待報到", value: 0 },
                        }),
                        _c("el-option", {
                          attrs: { label: "完成報到", value: 1 },
                        }),
                        _c("el-option", {
                          attrs: { label: "取消報到", value: -99 },
                        }),
                        _c("el-option", {
                          attrs: { label: "延期報到", value: -1 },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("label", { attrs: { for: "" } }, [_vm._v("組織代碼")]),
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "請輸入關鍵字" },
                      model: {
                        value: _vm.search.EmployeeGroupCodeKeyword,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.search,
                            "EmployeeGroupCodeKeyword",
                            typeof $$v === "string" ? $$v.trim() : $$v
                          )
                        },
                        expression: "search.EmployeeGroupCodeKeyword",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "col-sm-12 col-md-4" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    staticStyle: {
                      "margin-top": "30px",
                      "margin-left": "10px",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.getDetail({
                          page: 1,
                          per_page: _vm.pageSize,
                        })
                      },
                    },
                  },
                  [_vm._v(" 查詢 ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info",
                    staticStyle: {
                      "margin-top": "30px",
                      "margin-left": "10px",
                    },
                    on: { click: _vm.reportDownload },
                  },
                  [_vm._v(" 匯出報表 ")]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    staticStyle: {
                      "margin-top": "30px",
                      "margin-left": "10px",
                    },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.search = {}
                      },
                    },
                  },
                  [_vm._v(" 清除 ")]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "yahome-table-wrap", staticStyle: { padding: "20px" } },
        [
          _c(
            "el-table",
            {
              staticClass: "elTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.rows, height: "500px" },
              on: { "sort-change": _vm.sortChange },
            },
            [
              _c("template", { slot: "empty" }, [
                _c("span", [_vm._v("暫無數據")]),
              ]),
              _c("el-table-column", {
                attrs: {
                  prop: "Name",
                  label: "姓名",
                  fixed: "left",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Sex",
                  label: "性別",
                  fixed: "left",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "IdNo",
                  label: "身份證字號",
                  fixed: "left",
                  width: "120",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "MobilePhone",
                  label: "手機",
                  fixed: "left",
                  width: "120",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Birthday",
                  label: "生日",
                  width: "100",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$common.dateFormatter(scope.row.Birthday)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "Age", label: "年齡", sortable: "custom" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Email",
                  label: "Email",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Address",
                  label: "戶籍地址",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ContactAddress",
                  label: "通訊地址",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Nationality",
                  label: "國籍",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "HasDisabilityCardDesc",
                  label: "身障證明",
                  width: "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "EducationcategoryTop",
                  label: "學位",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "SchoolTop", label: "學校", sortable: "custom" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "MajorNameTop",
                  label: "科系",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ResumeTagTop",
                  label: "主要經驗分類",
                  width: "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ResumeTagSecond",
                  label: "次要經驗分類",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ResumeFreeTags",
                  label: "Hashtag(其他經驗)",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "TotalSeniority",
                  label: "總年資",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "WorkExperience",
                  label: "工作經歷",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Recommender",
                  label: "推薦人",
                  width: "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ContactStatus",
                  label: "聯繫狀況-主因",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ContactStatusSecond",
                  label: "聯繫狀況-二階原因",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ContactRemark",
                  label: "聯繫狀況備註",
                  width: "110",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "InterviewDate",
                  label: "預約面談日期",
                  width: "100",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$common.dateTimeFormatter(
                                scope.row.InterviewDate
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "InterviewDateActual",
                  label: "實際面談日期",
                  width: "100",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$common.dateTimeFormatter(
                                scope.row.InterviewDateActual
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "InterviewNotArrivedReason",
                  label: "預約未到原因分類",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "ManpowerDemandName",
                  label: "應徵職務",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "PersonInfoWorkShiftTypes",
                  label: "應徵班別",
                  width: "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "InterviewApprovalResult",
                  label: "面談結果",
                  width: "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "InterviewApprovedTime",
                  label: "面談評估完成時間",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$common.dateTimeFormatter(
                                scope.row.InterviewApprovedTime
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "HCPEmployeePlant",
                  label: "錄取廠區",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "HCPEmployeeDepartment",
                  label: "錄取部門",
                  width: "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "HCPEmployeeStation",
                  label: "錄取站點",
                  width: "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "HCPWorkShiftType",
                  label: "錄取班別",
                  width: "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "HCPAppointmentDepartment",
                  label: "任用部門",
                  width: "130",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "NoHiredReasonSupervisor",
                  label: "單位主管面談說明",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "NoHiredReasonHR",
                  label: "HR面談說明",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "NoHiredReasonSupervisorRemark",
                  label: "單位主管未錄取Remark匯出",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "NoHiredReasonHRRemark",
                  label: "HR未錄取Remark匯出",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "InterviewSupervisorEmpNo",
                  label: "單位面談主管工號",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "InterviewSupervisor",
                  label: "單位面談主管",
                  width: "120",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "InterviewHR",
                  label: "HR面談者",
                  width: "140",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "InterviewSupervisorPersonalRemark",
                  label: "個人備註(主管Remark)",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "InterviewHRPersonalRemark",
                  label: "個人備註(HR Remark)",
                  width: "200",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "OnBoardTime",
                  label: "預計報到日期",
                  width: "120",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$common.dateFormatter(scope.row.OnBoardTime)
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "OnBoardTimeActual",
                  label: "實際報到日期",
                  width: "120",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$common.dateFormatter(
                                scope.row.OnBoardTimeActual
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "OnBoard",
                  label: "報到結果",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "EmployeeNo",
                  label: "工號",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "NotArrivedCategory",
                  label: "未報到主因",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "NotArrivedCategorySecond",
                  label: "未報到原因",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "OnBoardRemark",
                  label: "未報到備註",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "SourceCategory",
                  label: "來源管道",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "SourceCategorySecond",
                  label: "來源管道(二階段)",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "OnBoardDataCompleted",
                  label: "報到資料已繳交完成",
                  width: "140",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(scope.row.OnBoardDataCompleted ? "是" : "否")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "EnglishName",
                  label: "英文名字",
                  width: "170",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "HCPEmployeeGroupCode",
                  label: "組織代碼",
                  sortable: "custom",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "HcpIsNeedTraining",
                  label: "是否進訓",
                  sortable: "custom",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.HcpIsNeedTraining === true
                          ? _c("span", [_vm._v("是")])
                          : scope.row.HcpIsNeedTraining === false
                          ? _c("span", [_vm._v("否")])
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.HcpIsNeedTraining)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "HcpRemark",
                  label: "HCP 備註",
                  width: "120",
                  sortable: "custom",
                },
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          "current-page": _vm.currentPage,
          "page-sizes": [5, 10, 20, 50],
          "page-size": _vm.pageSize,
          layout: "sizes, prev, pager, next",
          total: _vm.totalData,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }